import { WorkingStatus } from "../StepContent/WorkingStatus"
import { ExperienceYears } from "../StepContent/ExperienceYears"
import { LoginInformation } from "../StepContent/LoginInformation"
import { Birthday } from "../StepContent/Birthday"
import { CompanyName } from "../StepContent/CompanyName"
import { EmploymentStatus } from "../StepContent/EmploymentStatus"
import { Sex } from "../StepContent/Sex"
import { Prefecture } from "../StepContent/Prefecture"
import { FullName } from "../StepContent/FullName"
import { Tel } from "../StepContent/Tel"
import { EnrollmentPeriod } from "../StepContent/EnrollmentPeriod"
import { DetailedWorkDetails } from "../StepContent/DetailedWorkDetails"
import { ContentConfirmation } from "../StepContent/ContentConfirmation"
import { CuisineGenre } from "../StepContent/CuisineGenre/CuisineGenre"
import { JobContent } from "../StepContent/JobContent/JobContent"

export const Steps = [
    { Component: WorkingStatus },
    { Component: ExperienceYears },
    { Component: Sex },
    { Component: Birthday },
    { Component: Prefecture },
    { Component: FullName },
    { Component: Tel },
    { Component: LoginInformation },
    { Component: CompanyName },
    { Component: EmploymentStatus },
    { Component: EnrollmentPeriod },
    { Component: CuisineGenre },
    { Component: JobContent },
    { Component: DetailedWorkDetails },
    { Component: ContentConfirmation },
]
